import { render, staticRenderFns } from "./addAnalyseForm.vue?vue&type=template&id=610fd2de"
import script from "./addAnalyseForm.vue?vue&type=script&lang=js"
export * from "./addAnalyseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports